import { FILE_ICON_FILENAMES, FILE_ICON_GROUPS } from "./FileIconCatalog";

const CODE_FILENAMES = new Set<string>(FILE_ICON_FILENAMES);

const EXTENSION_GROUPS = new Map<string, (typeof FILE_ICON_GROUPS)[number]["id"]>(
  FILE_ICON_GROUPS.flatMap((group) =>
    group.extensions.map((extension) => [extension, group.id] as const),
  ),
);

export function getFileIconType(filename: string): {
  extension: string;
  family: (typeof FILE_ICON_GROUPS)[number]["id"] | "unknown";
} {
  const basename = filename.split(/[\\/]/).pop()?.toLowerCase() ?? "";
  if (CODE_FILENAMES.has(basename)) return { extension: "", family: "code" };
  for (let dot = basename.indexOf("."); dot !== -1; dot = basename.indexOf(".", dot + 1)) {
    const extension = basename.slice(dot + 1);
    const family = EXTENSION_GROUPS.get(extension);
    if (family) return { extension, family };
  }
  return { extension: "", family: "unknown" };
}
